/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Button, Modal} from '@scuf/common';
import {injectIntl} from "react-intl";
import {formatDateTime} from "./LocaleHelper";

class CorruptionModal extends React.Component {

    render() {
        const {intl} = this.props
        let corruptionContent = null;
        if (this.props.databaseCorruptionResult != null) {
            corruptionContent =
                <div>
                    <div className="div-reason">
                        <h4>{intl.formatMessage({id: 'corrupted.database.reason'})}</h4>
                        {this.props.databaseCorruptionResult.logString}
                    </div>
                    <div className="div-date">
                        <h4>{intl.formatMessage({id: 'corrupted.database.date'})}</h4>
                        {formatDateTime(this.props.databaseCorruptionResult.dateOfCorruption)}
                    </div>
                    <div className="div-user">
                        <h4>{intl.formatMessage({id: 'corrupted.database.user'})}</h4>
                        {this.props.databaseCorruptionResult.user}
                    </div>
                    <div className="div-impact">
                        <div className="div-red-color">
                            <h4>{intl.formatMessage({id: 'corrupted.database.impact'})}</h4>
                        </div>
                        {intl.formatMessage({id: 'corrupted.database.impact.text'})}
                    </div>
                    <div className="div-solution">
                        <div className="div-green-color">
                            <h4>{intl.formatMessage({id: 'corrupted.database.solution'})}</h4>
                        </div>
                        {intl.formatMessage({id: 'corrupted.database.solution.text'})}
                    </div>
                </div>
        }
        return (
            <React.Fragment>
                <Modal closeIcon={true} onClose={this.props.onClose} open={this.props.open} closeOnDimmerClick={false}>
                    <Modal.Header>
                        {intl.formatMessage({id: 'corrupted.database.topic'})}
                    </Modal.Header>
                    <Modal.Content>
                        {corruptionContent}
                    </Modal.Content>
                    <Modal.Footer>
                        <Button type="secondary" size="medium"
                                content={intl.formatMessage({id: 'corrupted.database.continue.anyway'})}
                                onClick={() => this.props.onClose()} className="mobile-max-width-button"/>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}

export default injectIntl(CorruptionModal)